import React, { useState } from 'react'
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2'
import CustomSelect from '../components/Form/CustomSelect';

const MeasuringBeneficiarySatisfaction = () => {

  const [selectedOption, setSelectedOption] = useState('موظف');
  const options = ['موظف', 'متطوع'];

  const sendEmail = (e) => { 
    e.preventDefault(); 
    emailjs.sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID_MEASURING_BENEFICIARY_SATISFACTION, e.target, process.env.REACT_APP_EMAILJS_PUBLIC_ID)
    .then((response) => {
      Swal.fire({
        icon: "success",
        // title: "Message sent successfully!",
        title: "تم إرسال الرسالة بنجاح!",
        draggable: true
      });
    })
    .catch((err) => {
        Swal.fire({
          icon: "error",
          // title: 'Failed to send message. Please try again later.',
          title: 'فشل في إرسال الرسالة. يرجى المحاولة مرة أخرى لاحقا.',
          draggable: true
        });
    });
  }

  const [formData, setFormData] = useState({
    name: '',
    email: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <div>
        <h1 className="text-white font-bold text-center bg-primary py-8">استبيان قياس رضا المستفيدين</h1>
      </div>
      
      <section className="pb-4 md:pb-10 pt-4 md:pt-10 max-w-screen-md mx-auto">
        <div className="max-w-screen-xl mx-auto px-3">
          <form onSubmit={sendEmail} className='shadow-[0_4px_20px_rgba(0,0,0,0.2)] px-4 py-8 md:px-10 md:py-16 -shadow-lg rounded'>
            <div className='grid gap-y-4'>
              {/* name */}
              <div className='grid gap-y-2'>
                <label htmlFor="name" className='font-semibold'>الاسم الكريم</label>
                <input type="text" name="name" id="name" className='border-2 rounded-full py-1 px-4 block w-full' placeholder="اكتب الاسم كاملاً" required="required" aria-required="true" value={formData.name} onChange={handleChange}/>
              </div>

              <div className="md:flex md:gap-4  ">
                {/* email */}
                <div className='grid gap-y-2 w-full'>
                  <label htmlFor="name" className='font-semibold'>البريد الإلكتروني</label>
                    <input type="email" name="email" id="name" className='border-2 rounded-full py-1 px-4 block w-full' placeholder="مثال: exmple@gmail.com" required="required" aria-required="true" value={formData.email} onChange={handleChange}/>
                </div>

                {/* mobile number */}
                <div className='grid gap-y-2 w-full'>
                  <label htmlFor="mobile_number" className='font-semibold'>رقم الجوال</label>
                    <input type="text" name="mobile_number" id="mobile_number" className='border-2 rounded-full py-1 px-4 block w-full' title="Only numbers and phone characters (#, -, *, etc) are accepted." placeholder="مثال:  12345656 966+ " required="required" aria-required="true"/>
                </div>
              </div>

              {/* sex */}
              <div className='grid gap-y-2'>
                <p className='font-semibold'>الجنس</p>
                <div className="flex items-center gap-4">
                  <div>
                    <input type="radio" name="sex" id="male" value={'M'}/>
                    <label htmlFor="male" className='mr-2'>
                      ذكر
                    </label>
                  </div>
                  <div>
                    <input type="radio" name="sex" id="female" value={'F'}/>
                    <label htmlFor="female" className='mr-2'>
                      أنثى
                    </label>
                  </div>
                </div>
              </div>
              
              {/* Relationship with the Associaton */}
              <CustomSelect 
                options={options} 
                value={selectedOption}
                onChange={setSelectedOption}
                name="relationship_with_the_associaton"
                id="relationship_with_the_associaton"
              />

              {/* How useful the services provided by the association? */}
              <div className='grid gap-y-2'>
                <p className='font-semibold'>ما مدى الاستفادة من الخدمات التي تقدمها الجمعية؟</p>
                <div className='flex items-center gap-x-2'>
                  <input type="radio" name="how_useful_are_the_sevices_provided_by_the_association" id="1_excellent" value={'excellent'}/>
                  <label htmlFor="1_excellent">
                    5/5 : ممتازة
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                    <input type="radio" name="how_useful_are_the_sevices_provided_by_the_association" id="1_very_good" value={'very_good'}/>
                    <label htmlFor="1_very_good">
                    4/5 : جيدة جداً
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                    <input type="radio" name="how_useful_are_the_sevices_provided_by_the_association" id="1_good" value={'good'}/>
                  <label htmlFor="1_good">
                    3/5 : جيدة
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                  <input type="radio" name="how_useful_are_the_sevices_provided_by_the_association" id="1_acceptable" value={'acceptable'}/>
                  <label htmlFor="1_acceptable">
                  2/5 : مقبولة
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                  <input type="radio" name="how_useful_are_the_sevices_provided_by_the_association" id="bad" value={'1_bad'}/>
                  <label htmlFor="1_bad">
                    1/5 : سيئة
                  </label>
                </div>
              </div>

              {/* How quickly do association staff contact you? */}
              <div className='grid gap-y-2'>
                <p className='font-semibold'>ما مدى سرعة تواصل موظفي الجمعية معك؟</p>
                <div className='flex items-center gap-x-2'>
                  <input type="radio" name="how_quickly_do_association_staff_contact_you" id="2_excellent" value={'excellent'}/>
                  <label htmlFor="2_excellent">
                    5/5 : ممتازة
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                    <input type="radio" name="how_quickly_do_association_staff_contact_you" id="2_very_good" value={'very_good'}/>
                    <label htmlFor="2_very_good">
                    4/5 : جيدة جداً
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                    <input type="radio" name="how_quickly_do_association_staff_contact_you" id="2_good" value={'good'}/>
                  <label htmlFor="2_good">
                    3/5 : جيدة
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                  <input type="radio" name="how_quickly_do_association_staff_contact_you" id="2_acceptable" value={'acceptable'}/>
                  <label htmlFor="2_acceptable">
                  2/5 : مقبولة
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                  <input type="radio" name="how_quickly_do_association_staff_contact_you" id="bad" value={'2_bad'}/>
                  <label htmlFor="2_bad">
                    1/5 : سيئة
                  </label>
                </div>
              </div>
              {/* How do you rate the quality of the association's services? */}
              <div className='grid gap-y-2'>
                <p className='font-semibold'>ما مدى تقييمك لجودة خدمات الجمعية؟</p>
                <div className='flex items-center gap-x-2'>
                  <input type="radio" name="how_do_you_rate_the_quality_of_the_association_services" id="3_excellent" value={'excellent'}/>
                  <label htmlFor="3_excellent">
                    5/5 : ممتازة
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                    <input type="radio" name="how_do_you_rate_the_quality_of_the_association_services" id="3_very_good" value={'very_good'}/>
                    <label htmlFor="3_very_good">
                    4/5 : جيدة جداً
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                    <input type="radio" name="how_do_you_rate_the_quality_of_the_association_services" id="3_good" value={'good'}/>
                  <label htmlFor="3_good">
                    3/5 : جيدة
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                  <input type="radio" name="how_do_you_rate_the_quality_of_the_association_services" id="3_acceptable" value={'acceptable'}/>
                  <label htmlFor="3_acceptable">
                  2/5 : مقبولة
                  </label>
                </div>
                <div className="flex items-center gap-x-2">
                  <input type="radio" name="how_do_you_rate_the_quality_of_the_association_services" id="bad" value={'3_bad'}/>
                  <label htmlFor="3_bad">
                    1/5 : سيئة
                  </label>
                </div>
              </div>
              <button type="submit" className='ml-auto bg-primary px-4 py-2 text-white rounded-xl'>اعتماد التقييم</button>
            </div>
          </form>
        </div>
      </section>
    </div>
  )
}

export default MeasuringBeneficiarySatisfaction